export default __webpack_public_path__ + "static/media/portfolioImage.dae6ff46.png";